import { ConstraintFacilityConstrainedScheduleDetailBase } from './base/constraint-facility-constrained-schedule-detail-base';

export class ConstraintFacilityConstrainedScheduleDetail extends ConstraintFacilityConstrainedScheduleDetailBase { }